import Immutable from 'seamless-immutable';
import ActionTypes from '../common/ActionTypes';

const DEFAULT_STATE = Immutable({
  subscription: {
    id: '',
    status: '',
    cancelAtPeriodEnd: false,
  },
  loading: true,
  failed: false,
  session: null,
});

export default function(state = DEFAULT_STATE, action = {}) {
  switch (action.type) {
    case ActionTypes.PREMIUM_CHECKOUT_SESSION:
      return state.setIn(['session'], action.session);
    case ActionTypes.CHECKOUT_SESSION_CLEARED:
      return state.setIn(['session'], action.session);
    case ActionTypes.SUBSCRIPTION_UPDATED:
      return state.setIn(['subscription'], action.data, { deep: true });
    case ActionTypes.SUBSCRIPTION_LOADING:
      return state.setIn(['loading'], action.loading);
    case ActionTypes.SUBSCRIPTION_FAILED:
      return state.setIn(['failed'], action.failed);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/premiumSubscription.js